import React, { useState } from 'react';
import { Package, Search } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

export default function OrderTracking() {
  const { t } = useTranslation();
  const [orderId, setOrderId] = useState('');
  const [email, setEmail] = useState('');
  const [result, setResult] = useState(null);

  const handleSearch = (e) => {
    e.preventDefault();
    if (!orderId) return;
    // Mock tracking response
    setResult({
      id: orderId.toUpperCase(),
      status: t('orderTracking.statusShipping'),
      steps: [
        { label: t('orderTracking.stepReceived'), date: t('orderTracking.stepReceivedDate'), done: true },
        { label: t('orderTracking.stepPrep'), date: t('orderTracking.stepPrepDate'), done: true },
        { label: t('orderTracking.stepShip'), date: t('orderTracking.stepShipDate'), done: false },
        { label: t('orderTracking.stepDelivery'), date: t('orderTracking.stepDeliveryDate'), done: false }
      ]
    });
  };

  return (
    <main>
      <section className="pt-20 pb-14 lg:pt-28 lg:pb-16 bg-ivory text-center">
        <div className="max-w-3xl mx-auto px-4 animate-fade-up">
          <div className="text-[11px] tracking-luxury uppercase text-gold mb-5">{t('orderTracking.label')}</div>
          <h1 className="font-serif text-5xl md:text-7xl font-light">{t('orderTracking.title')}</h1>
          <p className="mt-6 text-[#666]">{t('orderTracking.subtitle')}</p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-xl mx-auto px-4">
          <form onSubmit={handleSearch} className="space-y-4" data-testid="order-tracking-form">
            <div>
              <label className="text-[11px] tracking-luxury uppercase text-[#666] block mb-2">{t('orderTracking.orderNumber')}</label>
              <input
                type="text"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                placeholder={t('orderTracking.orderPlaceholder')}
                className="w-full bg-transparent border border-[#EAE4D8] px-4 py-3 focus:outline-none focus:border-gold text-sm"
                data-testid="order-tracking-input-id"
              />
            </div>
            <div>
              <label className="text-[11px] tracking-luxury uppercase text-[#666] block mb-2">{t('orderTracking.email')}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('orderTracking.emailPlaceholder')}
                className="w-full bg-transparent border border-[#EAE4D8] px-4 py-3 focus:outline-none focus:border-gold text-sm"
                data-testid="order-tracking-input-email"
              />
            </div>
            <button
              type="submit"
              data-testid="order-tracking-submit-button"
              className="w-full inline-flex items-center justify-center gap-3 bg-[#1A1A1A] text-white px-8 py-4 text-[11px] tracking-luxury uppercase hover:bg-gold transition-colors duration-500"
            >
              <Search className="w-4 h-4" /> {t('orderTracking.submit')}
            </button>
          </form>

          {result && (
            <div className="mt-12 border border-[#EAE4D8] p-8 bg-ivory" data-testid="order-tracking-result">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-12 rounded-full bg-cream flex items-center justify-center">
                  <Package className="w-5 h-5 text-gold" strokeWidth={1.2} />
                </div>
                <div>
                  <div className="text-[11px] tracking-luxury uppercase text-[#666]">{t('orderTracking.order')}</div>
                  <div className="font-serif text-xl">{result.id}</div>
                </div>
                <div className="ml-auto text-[11px] tracking-luxury uppercase text-gold">{result.status}</div>
              </div>

              <div className="space-y-6">
                {result.steps.map((s, i) => (
                  <div key={i} className="flex gap-4 items-start">
                    <div className={`w-3 h-3 rounded-full mt-1.5 ${s.done ? 'bg-gold' : 'bg-[#EAE4D8]'}`} />
                    <div className="flex-1">
                      <div className="font-serif text-lg">{s.label}</div>
                      <div className="text-xs text-[#888] tracking-luxury uppercase mt-1">{s.date}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
